const carousel = {
  product: {
    variations: 'Kunden kauften auch',
    recommendations: 'Produktempfehlungen',
    offer: 'Unsere Angebote',
    offerLink: 'Zur Produktübersicht',
    indicator: 'Produkte des Monats',
  },
  card: {
    prescriptionMsg: 'Laden Sie ein (E-)Rezept hoch, um dieses Produkt zu reservieren.',
    pricesMayVary: 'Preise variieren je nach Apotheke.',
    toProduct: 'Zum Produkt',
    toCart: 'In den Warenkorb',
    uploadPrescription: '(E-)Rezept hochladen',
  },
}

export default carousel
